'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _PresenceActions = require('conversations-core/actions/PresenceActions');

var _RepStatus = require('conversations-core/constants/RepStatus');

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _pubNubStatusSelectors = require('conversations-core/selectors/pubNubStatusSelectors');

var _helpers = require('conversations-core/utils/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MINUTE_IN_MS = 60000;
var heartbeatInterval = null;

var offlineActionsToCheck = (0, _immutable.List)([_ActionTypes2.default.LEAVE_LOBBY, _ActionTypes2.default.LEAVE_CHANNELS, _ActionTypes2.default.START_CHANNEL_SUBSCRIBE_POLL]);

function shouldSendOnlineNotice(action, _ref) {
  var wasResubscribing = _ref.wasResubscribing,
      isRepOnline = _ref.isRepOnline;

  switch (action.type) {
    case _ActionTypes2.default.SUBSCRIBE_CONFIRMATION:
      return wasResubscribing;

    case _ActionTypes2.default.JOIN_LOBBY:
    case _ActionTypes2.default.CONVERSATIONS_CLIENT_READY:
    case _ActionTypes2.default.SET_REP_STATUS_SUCCEEDED:
      return isRepOnline;

    default:
      return false;
  }
}

function shouldSendOfflineNotice(action, _ref2) {
  var wasRepOnline = _ref2.wasRepOnline;

  return offlineActionsToCheck.includes(action.type) && wasRepOnline;
}

exports.default = function (store) {
  var dispatch = store.dispatch,
      getState = store.getState;


  var startHeartbeatInterval = function startHeartbeatInterval() {
    heartbeatInterval = setInterval(function () {
      dispatch((0, _PresenceActions.sendHeartbeat)());
    }, MINUTE_IN_MS);
  };

  var clearHeartbeatInterval = function clearHeartbeatInterval() {
    if (heartbeatInterval === null) return;

    clearInterval(heartbeatInterval);
    heartbeatInterval = null;
  };

  return function (next) {
    return function (action) {
      // before next(action) is called
      var wasResubscribing = (0, _pubNubStatusSelectors.getIsResubscribing)(getState());
      var wasRepOnline = getState().repStatus === _RepStatus.repStatuses.ONLINE;

      var nextAction = next(action);

      // after next(action) is called
      var isAdmin = (0, _clientSelectors.getIsAdmin)(getState());
      var isRepOnline = getState().repStatus === _RepStatus.repStatuses.ONLINE;

      if (!isAdmin) {
        return nextAction;
      }

      if (shouldSendOnlineNotice(action, { wasResubscribing: wasResubscribing, isRepOnline: isRepOnline })) {
        dispatch((0, _PresenceActions.sendOnlineNotice)());

        startHeartbeatInterval();
      }

      if (shouldSendOfflineNotice(action, { wasRepOnline: wasRepOnline })) {
        clearHeartbeatInterval();

        dispatch((0, _PresenceActions.sendOfflineNotice)());

        if (action.type === _ActionTypes2.default.LEAVE_CHANNELS) {
          (0, _helpers.sleepBeforeProceeding)();
        }
      }

      return nextAction;
    };
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/middleware/PresenceMiddleware.js
// module id = 484
// module chunks = 0